<template>
    <div class="feedback-wrapper">
        <el-dropdown
                ref="dropdown"
                placement="top-end"
                hide-on-click
                @visible-change="visibleChange">
            <div class="feedback">
                <img src="@/assets/img/toolbar/support_icn.svg" width="18px" alt="" style="margin-right: 5px;">
                {{$t('menu_support')}}
            </div>
            <el-dropdown-menu class="dropdown2" slot="dropdown" placement="bottom-end">
                <div class="wrapper">
                    <el-row type="flex" :span="24" :gutter="10" justify="space-between">
                        <el-col>
                            <div class="col-title">
                                {{$t('modal_feedback_reachout')}}
                            </div>
                            <div class="col-content">
                                <div class="link" @click="selectedFeedback(2)">
                                    <i class="fas fa-exclamation-triangle"></i>
                                    {{$t('modal_feedback_error')}}
                                </div>
                                <div class="link" @click="selectedFeedback(3)">
                                    <i class="fas fa-question-circle"></i>
                                    {{$t('modal_feedback_help')}}
                                </div>
                                <div class="link" @click="selectedFeedback(1)">
                                    <i class="fas fa-thumbs-up"></i>
                                    {{$t('modal_feedback_feedback')}}
                                </div>
                                <div class="link" @click="selectedFeedback(4)">
                                    <i class="fas fa-comment-dots"></i>
                                    {{$t('modal_feedback_enquiries')}}
                                </div>
                                <div class="link" @click="selectedFeedback(5)">
                                    <i class="fas fa-calculator"></i>
                                    {{$t('modal_feedback_accounting_issues')}}
                                </div>
                                <div class="link" @click="sentsInvite">
                                  <i class="fas fa-ad"></i>
                                    Promote totalflow
                                </div>
                            </div>
                        </el-col>
                        <el-col>
                            <div class="col-title">
                                {{$t('modal_feedback_explore')}}
                            </div>
                            <div class="col-content">
                                <div
                                    class="link"
                                    v-for="item in supportPage"
                                    :key="item.id"
                                    @click="item.url ? supportPageClick(item.url) : null">
                                    {{item.name}}
                                </div>
                            </div>
                        </el-col>
                        <el-col>
                            <div class="col-title">
                                <router-link :to="`/projects?companyId=${this.$route.query.companyId}`">
                                    <!-- <img src="@/assets/img/tf_logo_inverse.png" alt="Totalflow" height="20px"> -->
                                    <img src="@/assets/img/tf_l.jpg" alt="Totalflow" height="20px">
                                </router-link>
                            </div>
                            <div class="col-content">
                                 <div v-for="news in newsMenu"
                                     :key="news.id"
                                     @click="openNews(news.translations[0].titleTranslation, news.createDate, news.translations[0].textTranslation)"
                                     class="link">
                                    {{news.translations[0].titleTranslation}}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="footer-row" type="flex" :span="24" :gutter="10" justify="space-between">
                        <el-col>
                            <div v-if="companyLayout" class="menu__size">
                                <div class="menu__size_item">{{$t('menu_storage_capacity')}}:</div>
                                <el-tooltip effect="light" placement="bottom-start" :content="`You are currently using ${(companyLayout.storageSize / 1073741824).toFixed(2)} GB (${Math.round((100 * companyLayout.storageSize) / companyLayout.fullSize)} %) of your ${(companyLayout.fullSize / 1073741824).toFixed(2)} GB`">
                                    <div class="menu__size_item" style="cursor: pointer;"><el-progress  :percentage="Math.round((100 * companyLayout.storageSize) / companyLayout.fullSize)" :color="customColorMethod"></el-progress></div>
                                </el-tooltip>
                            </div>
                            <br>
                            <!-- <span class="menu__size">{{$t('menu_v')}}</span> -->
                            <span class="menu__size">v.{{version.version}} {{moment(version.createdDate * 1000).format('D MMMM, YYYY hh:mm a')}}</span>
                        </el-col>
                        <el-col>
                        </el-col>
                    </el-row>
                </div>
            </el-dropdown-menu>
        </el-dropdown>
        <sweet-modal blocking :title="title" ref="feedback" class="modal" v-on:close="closeModalFeedback">
            <el-form :model="formFeedback" status-icon :rules="rulesFeedback" ref="formF" class="demo-ruleForm">
                <el-form-item prop="subject" >
                    <el-input v-model="formFeedback.subject" :label="$t('modal_subject')"></el-input>
                </el-form-item>
                <vue2-custom-editor
                        v-model="formFeedback.message"
                        ref="feedbackEditor"
                        style="margin-bottom: 20px;">
                </vue2-custom-editor>
                <el-form-item class="modal__btn">
                    <el-button @click="modalCancel('feedback')">{{$t('general_cancel')}}</el-button>
                    <el-button :disabled="!(formFeedback.message)" @click="submitFormFeedback('formF')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <sweet-modal blocking :title="valueTitle" :subtitle="valueTime" ref="news" class="modal">
            <div class="modal__content" v-html="valueContent"></div>
        </sweet-modal>

        <!-- [ Modal Invite Company] start -->
        <sweet-modal blocking :title="$t('modal_invite_company')" ref="invite" class="modal" v-on:close="closeModal">

            <el-form @submit.prevent.native="submitForm('form')" :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">
                <el-form-item prop="inviteEmail">
                    <el-input :label="$t('modal_email')" size="mini" v-model="form.inviteEmail"></el-input>
                </el-form-item>
                <el-form-item label-width="0" class="modal__btn">
                  <el-button @click="modalCancel('invite')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="submitForm('form')" class="modal__btn" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <!-- [ Modal Invite Company] end -->

    </div>
</template>

<script>
    import moment from 'moment'
    import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
    import axios from 'axios'
    import Vue2CustomEditor from "../../components/vue-2-custom-editor/index";
    export default {
        name: "SupportDropdown",
        components: {
            Vue2CustomEditor,
            SweetModal
        },
        data() {
            return {
                version: '',
                moment:moment,
                valueTitle: '',
                valueTime: '',
                valueContent: '',
                supportPage: [],
                formFeedback: {
                    type: 0,
                    message: '',
                    subject: ''
                },
                rulesFeedback: {
                    subject: [{
                        required: true,
                        message: this.$i18n.t('modal_feedback_subjectIsRequired'),
                        trigger: 'change'
                    }],
                },
                // Invite
                form: {
                    inviteEmail: '',
                },
                rules: {
                    inviteEmail: [
                        { required: true, message: 'Please input Email address', trigger: 'blur' },
                        { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
                    ],
                }
            }
        },
        computed: {
            newsMenu() {
                return this.$store.state.newsMenu
            },
            title: function () {
                return (this.formFeedback.type === 0) ? this.$t('modal_feedback') :
                    (this.formFeedback.type === 1) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_feedback')}` :
                    (this.formFeedback.type === 2) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_error')}` :
                    (this.formFeedback.type === 3) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_help')}` :
                    (this.formFeedback.type === 4) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_enquiries')}` :
                    (this.formFeedback.type === 5) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_accounting_issues')}` : this.$t('modal_feedback')

            },
            companyLayout() {
                return this.$store.getters.getCompanyLayout
            },
        },
        mounted() {
            this.getVersion()
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                .post(`/api/v1/support-page/list`)
                .then(response => {
                    this.supportPage = response.data.list
                    loader.hide()
                })
                .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                })
        },
        methods: {
            sentsInvite() {
                this.$refs['invite'].open()
            },
            submitForm(form) {
                this.$refs['form'].validate((valid) => {
                if (valid) {
                    let loader = this.$loading.show();
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                    axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                    axios
                    .post(`/api/v1/advertising/system?email=${this.form.inviteEmail}`)
                    .then(response => {
                        // console.log('---', response.data);
                        this.$refs.invite.close();
                        loader.hide()
                        this.notification("Success", "Invite Company", "success");
                        this.$refs['form'].resetFields();
                    })
                    .catch(error => {
                        console.log('An error occurred:', error);
                        // this.$refs.invite.close();
                        loader.hide()
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            closeModal() {
                this.$refs['form'].resetFields();
            },
            getVersion() {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/version/item`)
                .then(response => {
                    this.version = response.data.version
                })
                .catch(error => {
                    console.log('An error occurred:', error);
                });
            },
            visibleChange(val) {
                if (val) this.$store.dispatch('getNewsMenu', localStorage.getItem('lang'));
            },
            selectedFeedback(type) {
                this.$refs['feedback'].open();
                this.formFeedback.type = type;
                this.formFeedback.message = '';
                this.formFeedback.subject = ''
            },
            closeModalFeedback() {
                this.formFeedback.type = 0;
                this.formFeedback.message = '';
                this.formFeedback.subject = ''
            },
            submitFormFeedback(form) {
                this.$refs[form].validate((valid) => {
                    if (valid && this.formFeedback.message) {
                        console.log('submit');

                        let loader = this.$loading.show();
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                        axios
                            .post(`/api/v1/feedback/create?companyId=${this.$route.query.companyId}`, {
                                subjectType: this.formFeedback.type,
                                message: this.formFeedback.message,
                                subject: this.formFeedback.subject
                            })
                            .then(response => {
                                this.notification("Success", "Thank you for report", "success");
                                this.formFeedback.message = ''
                                this.formFeedback.subject = ''
                                this.$refs.feedback.close();
                                loader.hide()
                                if (this.$refs.feedbackEditor.uploadedImagesArray.length) {
                                    this.$store.dispatch('approveUploadedImages', {
                                        fileUrlArr: this.$refs.feedbackEditor.uploadedImagesArray,
                                        entityId: response.data.feedbackId,
                                        entityTypeId: 52 // feedback
                                    })
                                }
                            })
                            .catch(error => {
                                console.log('An error occurred:', error);
                                loader.hide()
                            })

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            notification(title, message, type) {
                this.$notify({
                    title: title,
                    message: message,
                    type: type
                });
            },
            customColorMethod(percentage) {
                if (percentage < 30) {
                    return '#67c23a';
                } else if (percentage < 70) {
                    return '#e6a23c';
                } else {
                    return '#f56c6c';
                }
            },
            modalCancel(ref) {
                this.$refs[ref].close();
            },
            supportPageClick(url) {
                const newUrl = this.getValidUrl(url)
                window.open(newUrl)
            },
            getValidUrl(url) {
                let newUrl = window.decodeURIComponent(url)
                newUrl = newUrl.trim().replace(/\s/g, '')

                if (/^(:\/\/)/.test(newUrl)) {
                    return `http${newUrl}`
                }
                if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
                    return `http://${newUrl}`
                }

                return newUrl
            },
            openNews(title, time, content) {
                this.valueTitle = title
                this.valueTime = `Post time: ${moment(time * 1000).format("D MMM YY, h:mm a")}`,
                this.valueContent = content
                this.$refs['news'].open()
            },
        }
    }
</script>

<style lang="scss" scoped>
    .feedback-wrapper {
        margin-right: 39px;
    }
    .feedback {
        display: flex;
        background: #DFE8F0;
        color: #4277A6;
        border-radius: 3px;
        padding: 5px;
        cursor: pointer;
        white-space: nowrap;
        &:hover {
            animation: glow 800ms ease-out infinite alternate;
            background: #fff;
            border-color: #393;
            box-shadow: 0 0 7px rgba(255, 240, 160, .2), inset 0 0 7px rgba(255, 240, 160, .2);
            color: #4277A6;
            outline: none;
        }
    }
    .dropdown2 {
        background-color: #2a3652;
        padding: 20px;
        width: 640px;
        /deep/.popper__arrow {
            display: none !important;
        }
    }
    .wrapper {
        .el-row {
            padding: 10px;
            .col-title {
                text-transform: uppercase;
                font-size: 14px;
                color: #fff;
                text-decoration: underline;
                min-height: 30px;
            }
            .col-content {
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                .link {
                    margin-bottom: 5px;
                    font-size: 14px;
                    cursor: pointer;
                    color: #fff !important;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
        .footer-row {
            margin-top: 20px;
            align-items: center;
        }
        .menu__size {
            font-size: 14px;
            color: #fff !important;
        }
        /deep/.el-progress__text {
            color: #fff !important;
        }
    }
</style>
